import { render, staticRenderFns } from "./AsStampIndex.vue?vue&type=template&id=747c57cc"
import script from "./AsStampIndex.vue?vue&type=script&lang=js"
export * from "./AsStampIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports